"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Download = function Download(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 20 22",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 1.3
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,15 L0,18 C0,19.1045695 0.8954305,20 2,20 L16,20 C17.1045695,20 18,19.1045695 18,18 L18,15",
    id: "Shape"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    id: "Shape",
    points: "5 10 9 14 13 10"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9,0 L9,14",
    id: "Shape"
  }))))));
};
var _default = exports.default = Download;